<template>
    <div>
        <div class="cart__item-line cart__item-line--1">
            <div class="cart__item-img-block"><img class="cart__item-img" :src="cartitemLocal.img" alt=""/></div>
            <div class="cart__item-info"><a class="cart__item-link" :href="cartitemLocal.url">{{ cartitemLocal.name }}</a>
                <div v-if="cartitemLocal.variant_id > 0">{{ cartitemLocal.variant_name }}</div>
                <div class="cart__item-desc">{{ cartitemLocal.name_rus}}</div>
                <div class="cart__item-info-line">
                    <div class="cart__item-artnumber">Арт. {{ cartitemLocal.article }}</div>

                    <div class="cart__item-payment-type">
                        <input @change="changeData" v-model="cartitemLocal.add_prop" type="radio" id="serv1" name="add_prop" value="300" />
                        <label for="serv1">Ремонт</label>
                        <input @change="changeData" v-model="cartitemLocal.add_prop" type="radio" id="serv2" name="add_prop" value="387" />
                        <label for="serv2">Обкатка</label>
                        <input @change="changeData" v-model="cartitemLocal.add_prop" type="radio" id="serv3" name="add_prop" value="388" />
                        <label for="serv3">Настройка двигателя</label>
                        <input @change="changeData" v-model="cartitemLocal.add_prop" type="radio" id="serv4" name="add_prop" value="389" />
                        <label for="serv4">Сборка</label>
                        <input @change="changeData" v-model="cartitemLocal.add_prop" type="radio" id="serv5" name="add_prop" value="13" />
                        <label for="serv5">Предоплата</label>
                    </div>
                </div>
                <div class="cart__item-info-line mt-4">
                    <div>
                        <label>Стоимость:</label>
                        <input v-model="cartitemLocal.service_price" @change="changeData" type="text" class="cart__promo-input"/>
                    </div>
                </div>

            </div>
            <div class="cart__item-offer">
                <div class="cart__item-price">
                    <div class="cart__item-cur-price">{{ cartitemLocal.service_price | formatCurrency}} ₽</div>
                </div>
            </div>
        </div>

        <div v-if="cartitemLocal.add_prop==='300'" class="cart__item-info-line mt-4">
            <div>
                <label>Работа:</label>
                <select multiple v-model="selectWork" @change="changeSelectData" class="select_options">
                    <option v-for="item in selectWorkData" :key="item.id" :value="item.id">{{ item.name }} {{ item.value}}р.</option>
                </select>
            </div>
            <div>
                <label>Обслуживание (переборка) модели:</label>
                <select multiple v-model="selectService" @change="changeSelectData" class="select_options">
                    <option v-for="item in selectServiceData" :key="item.id" :value="item.id">{{ item.name }} {{ item.value}}р.</option>
                </select>
            </div>
            <div>
                <label>Доп. услуги:</label>
                <select multiple v-model="selectAdd" @change="changeSelectData" class="select_options">
                    <option v-for="item in selectAddData" :key="item.id" :value="item.id">{{ item.name }} {{ item.value}}р.</option>
                </select>
            </div>
        </div>

        <div v-if="cartitemLocal.add_prop==='300'" class="mt-4">

            <div v-for="item in selectWork"><a @click.prevent="deleteItem(selectWork, item)" href="#">[x]</a> {{ getSelectedValue(selectWorkData, item) }}</div>

            <div v-for="item in selectService"><a @click.prevent="deleteItem(selectService, item)" href="#">[x]</a> {{ getSelectedValue(selectServiceData, item) }}</div>

            <div v-for="item in selectAdd"><a @click.prevent="deleteItem(selectAdd, item)" href="#">[x]</a> {{ getSelectedValue(selectAddData, item) }}</div>

        </div>

    </div>
</template>

<script>
export default {
    name: "cart-list-item",
    props: ['cartitem'],
    data () {
        return {
            cartitemLocal:this.cartitem,
            selectWork:[],
            selectWorkData: [
                {
                    id: '1',
                    name: 'Замена узлов шасси (1-2часа)',
                    value: '1000'
                },
                {
                    id: '2',
                    name: 'Замена электроники (1-2часа)',
                    value: '1300'
                },
                {
                    id: '3',
                    name: 'Замена рамы (дэки) (2-3часа)',
                    value: '2500'
                },
                {
                    id: '4',
                    name: 'Замена шестерней серво (1час)',
                    value: '800'
                },
                {
                    id: '5',
                    name: 'Обкатка мотора (ДВС) (4-5часов)',
                    value: '3200'
                },
                {
                    id: '6',
                    name: 'Установка/замена аксессуаров (1-2часа)',
                    value: '1200'
                },
            ],
            selectService:[],
            selectServiceData: [
                {
                    id: '7',
                    name: 'Масштаб 1/18 (1-3дня)',
                    value: '2500'
                },
                {
                    id: '8',
                    name: 'Масштаб 1/16 (1-3дня)',
                    value: '3000'
                },
                {
                    id: '9',
                    name: 'Масштаб 1/10 (2-3дня)',
                    value: '4000'
                },
                {
                    id: '10',
                    name: 'Масштаб 1/8 (2-3дня)',
                    value: '5000'
                },
                {
                    id: '11',
                    name: 'Масштаб 1/5 (3-4дня)',
                    value: '6000'
                },
            ],
            selectAdd:[],
            selectAddData: [
                {
                    id: '12',
                    name: 'Пайка',
                    value: '600',
                },
                {
                    id: '13',
                    name: 'Мойка',
                    value: '800',
                },
                {
                    id: '14',
                    name: 'Диагностика',
                    value: '800',
                },
            ]
        }
    },
    methods: {
        getSelectedValue (arr, id) {
            let f = arr.filter(function (item) {

                return item.id === id
            })
            if(f.length) {
                return f[0].name + ' ' + f[0].value + 'р.'
            }
            return '';
        },
        deleteItem(arr, id) {
            const index = arr.indexOf(id);
            if(index > -1) {
                arr.splice(index, 1)
                this.changeSelectData()
            }
        },
        changeData () {
            this.$store.dispatch('changeProductService', {
                price: this.cartitemLocal.service_price,
                prop: this.cartitemLocal.add_prop,
                cart_item_id: this.cartitemLocal.id}
            )
        },
        changeSelectData () {
            let total = 0;
            let addinfo_master='';
            for(const id of this.selectWork) {
                let s = this.selectWorkData.filter(function (item) {
                    return item.id === id
                })
                total += parseInt(s[0].value)
                addinfo_master += s[0].id + ";" + s[0].name + " " + s[0].value + "\r\n";
            }
            for(const id of this.selectService) {

                let s = this.selectServiceData.filter(function (item) {
                    return item.id === id
                })
                total += parseInt(s[0].value)
                addinfo_master += s[0].id + ";" + s[0].name + " " + s[0].value + "\r\n";
            }
            for(const id of this.selectAdd) {

                let s = this.selectAddData.filter(function (item) {
                    return item.id === id
                })
                total += parseInt(s[0].value)
                addinfo_master += s[0].id + ";" + s[0].name + " " + s[0].value + "\r\n";
            }

            this.cartitemLocal.service_price = total
            this.changeData()
            this.saveData(addinfo_master)

        },
        async saveData(addinfo_master) {
            let params = new URLSearchParams();
            params.append('action', 'set_addinfo_master')
            params.append('repair_addinfo_master', addinfo_master)

            let param = yii.getCsrfParam();
            let token = yii.getCsrfToken();
            params.append(param, token)

            axios
                .put('/rest/spec', params)
                .then((response) => {
                    this.$store.commit('setLoading', false)
                }).catch(error => {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', error.message)
                throw error
            })
        },
        async loadData() {
            try {
                let params = new URLSearchParams();
                params.append('action', 'get_spec_data');
                axios
                    .get('/rest/spec', {params})
                    .then((response) => {

                        let data = JSON.parse(response.data);

                        let s = data.repair_addinfo_master;
                        let arr = s.split("\r\n");

                        for(const l of arr) {
                            const p = l.split(';');

                            let f = this.selectWorkData.filter(function (item) {
                                return item.id === p[0]
                            });
                            if(f.length) {
                                this.selectWork.push(p[0])
                            }

                            f = this.selectServiceData.filter(function (item) {
                                return item.id === p[0]
                            });
                            if(f.length) {
                                this.selectService.push(p[0])
                            }

                            f = this.selectAddData.filter(function (item) {
                                return item.id === p[0]
                            });
                            if(f.length) {
                                this.selectAdd.push(p[0])
                            }
                        }
                    })
            } catch(error) {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', error.message)
                throw error
            }
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>

<style scoped>
.select_options {
    margin-right: 5px;
    font-size: 15px;
    background: #f2f2f2;
    height: 140px;
    width:95%
}
.cart__item-info-line label {
    font-size: 15px;

}
</style>
